import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/hotActivity/detail.vue'
createPage(Page)